module.exports = __webpack_public_path__ + "44ddbba5ac8ce4f6a92b5d9359e8fc55.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Elvidge.png
// module id = kGi9
// module chunks = 0